// Seamless horizontal auto-scroll. Renders two identical copies and translates
// the track by -50% so the loop is continuous. Pauses on hover.
export default function Marquee({ children, reverse = false, className = "" }) {
  return (
    <div className={`group flex overflow-hidden ${className}`}>
      <div
        className={`flex shrink-0 items-stretch ${
          reverse ? "animate-marqueeRev" : "animate-marquee"
        } group-hover:[animation-play-state:paused]`}
      >
        <span className="flex shrink-0 items-stretch">{children}</span>
        <span aria-hidden="true" className="flex shrink-0 items-stretch">
          {children}
        </span>
      </div>
    </div>
  );
}
